import React, { useEffect, useState } from "react";

export default function CursorHalo() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [hovering, setHovering] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    setVisible(true);
    let raf = 0;
    const onMove = (e) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setPos({ x: e.clientX, y: e.clientY }));
    };
    const onOver = (e) => {
      const t = e.target;
      if (t && t.closest && t.closest("a, button, [data-cursor='hover']")) setHovering(true);
      else setHovering(false);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(raf);
    };
  }, []);

  if (!visible) return null;
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed top-0 left-0 z-[100] mix-blend-multiply"
      style={{
        transform: `translate3d(${pos.x}px, ${pos.y}px, 0) translate(-50%, -50%) scale(${hovering ? 2.4 : 1})`,
        transition: "transform 220ms cubic-bezier(0.22, 1, 0.36, 1)",
      }}
    >
      <div
        className="w-7 h-7 rounded-full"
        style={{
          background: "radial-gradient(circle at 30% 30%, rgba(255,107,158,0.85), rgba(167,139,250,0.6) 60%, rgba(56,189,248,0.3) 100%)",
          filter: "blur(2px)",
        }}
      />
    </div>
  );
}
